(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["itad-apps"] && !Shopify.designMode) return;
  try {
    
function connectAssessmentLabels(host) {
  if (!host.shadowRoot || host.dataset.itadLabelsConnected) return;
  host.dataset.itadLabelsConnected = 'true';
  const root = host.shadowRoot;
  const connect = () => {
    root.querySelectorAll('label[for]').forEach(label => {
      const id = label.htmlFor;
      if (root.getElementById(id)) return;
      const field = Array.from(root.querySelectorAll('input[name],textarea[name],select[name]')).find(input => input.name === id && !input.id);
      if (field) field.id = id;
    });
  };
  connect();
  new MutationObserver(connect).observe(root, {childList:true,subtree:true});
}
customElements.whenDefined('shopify-forms-embed').then(() => {
  const attach = () => document.querySelectorAll('.itad-assessment-inner shopify-forms-embed').forEach(connectAssessmentLabels);
  attach();
  document.querySelectorAll('.itad-assessment-inner').forEach(container => new MutationObserver(attach).observe(container, {childList:true,subtree:true}));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itad-design"]) return;
  try {
    
document.addEventListener('click',function(event){const toggle=event.target.closest('[data-itad-menu]');if(toggle){const nav=document.getElementById('itad-navigation');const opened=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(opened))}const print=event.target.closest('[data-print-report]');if(print)window.print();const anchor=event.target.closest('a');if(anchor){let eventName=anchor.dataset.itadEvent;if(anchor.href.startsWith('tel:'))eventName='phone_click';if(anchor.href.startsWith('mailto:'))eventName='email_click';if(eventName){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'itad_'+eventName,link_text:anchor.textContent.trim(),page_path:location.pathname})}}});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){const nav=document.getElementById('itad-navigation');const toggle=document.querySelector('[data-itad-menu]');const focused=document.activeElement;const detail=focused?.closest('.itad-nav details[open]');const mobileOpen=nav?.classList.contains('is-open');document.querySelectorAll('.itad-nav details[open]').forEach(d=>d.open=false);nav?.classList.remove('is-open');toggle?.setAttribute('aria-expanded','false');if(mobileOpen&&nav?.contains(focused))toggle?.focus();else if(detail)detail.querySelector('summary')?.focus()}});
document.addEventListener('click',function(event){const link=event.target.closest('#itad-navigation a');if(link){const nav=document.getElementById('itad-navigation');nav?.classList.remove('is-open');document.querySelector('[data-itad-menu]')?.setAttribute('aria-expanded','false');document.querySelectorAll('.itad-nav details[open]').forEach(d=>d.open=false)}});
document.querySelectorAll('.itad-nav details').forEach(detail=>detail.addEventListener('toggle',()=>{if(detail.open)document.querySelectorAll('.itad-nav details').forEach(other=>{if(other!==detail)other.open=false})}));
if(document.querySelector('[data-itad-success]')){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'itad_assessment_submitted'})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbr-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.carouselReady === 'true') return;
      root.dataset.carouselReady = 'true';
      const slides = [...root.querySelectorAll('[data-carousel-slide]')];
      const dots = [...root.querySelectorAll('[data-carousel-dot]')];
      if (slides.length < 2) return;
      const toggle = root.querySelector('[data-carousel-toggle]');
      let current = 0;
      let timer;
      let paused = false;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, i) => {
          const active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (root.dataset.autoplay === 'true' && !reduced && !paused) {
          timer = setInterval(() => show(current + 1), Number(root.dataset.speed) || 6000);
        }
      };
      const setPaused = (nextPaused) => {
        paused = nextPaused;
        if (!toggle) return;
        toggle.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
        toggle.setAttribute('aria-label', toggle.textContent);
        if (paused) stop(); else start();
      };
      root.querySelector('[data-carousel-previous]')?.addEventListener('click', () => { show(current - 1); start(); });
      root.querySelector('[data-carousel-next]')?.addEventListener('click', () => { show(current + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.carouselDot)); start(); }));
      toggle?.addEventListener('click', () => setPaused(!paused));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') show(current - 1);
        if (event.key === 'ArrowRight') show(current + 1);
      });
      document.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { show(index); stop(); }
      });
      show(0);
      start();
    };
    document.querySelectorAll('[data-tbr-carousel]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-tbr-carousel]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();
})();
